// File for logic corresponding to article-table-of-contents component
import { Component } from 'js-component-framework';
import './index.scss';

/**
 * Component for Article Content Table of Contents.
 */
export default class ArticleTOC extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.articleContent = document.querySelector('article[id^="post-"]');
    this.initNavigation();
  }

  /**
   * Toggle active section in TOC.
   *
   * @param {HTMLElement} el the HTML element
   * @param {Boolean} setActive true to add active state or false to remove. true by default
   */
  toggleActiveSection(el, setActive = true) {
    const { activeClass } = this.options;

    if (setActive) {
      el.classList.add(activeClass);
      el.querySelector('a').setAttribute('aria-current', true);
    } else {
      el.classList.remove(activeClass);
      el.querySelector('a').removeAttribute('aria-current');
    }
  }

  /**
   * Initialize TOC Navigation.
   */
  initNavigation() {
    const { links } = this.children;

    if (!(links instanceof NodeList)) {
      return;
    }

    // Always add active class to first item on initialization.
    const firstSection = links[0]?.parentElement ?? null;
    if (firstSection) {
      this.toggleActiveSection(firstSection);
    }

    links.forEach((link) => {
      const { hash = '' } = link;

      // This works for Ingested content.
      let hashElement = this.articleContent.querySelector(`${hash}`);

      if (!hashElement) {
        // This works for migrated content.
        hashElement = this.articleContent.querySelector(`a[name="${hash.substring(1)}"]`);
      }

      if (!hashElement) {
        // Still no element to navigate to. Bail early.
        return;
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const { activeClass } = this.options;
        const activeElement = this.element.querySelector(`li.${activeClass}`);
        const newActiveElement = link.parentElement;

        if (activeElement) {
          // Remove previously set active state.
          this.toggleActiveSection(activeElement, false);
        }

        /**
         * Scroll to the active element. If scrolling up, add an offset equivalent to the
         * height of the header to prevent the header from obscuring the active element.
         */
        const headerHeight = document.querySelector('header')?.offsetHeight ?? 0;
        const rect = hashElement.getBoundingClientRect();

        // If rect.y is -1, we're scrolling up. Add an offset.
        const scrollOffset = Math.sign(rect?.y) === -1 ? headerHeight : 0;

        window.scroll({
          top: hashElement.offsetTop - scrollOffset,
          behavior: 'smooth',
        });

        if (newActiveElement) {
          // Add active state to new element.
          this.toggleActiveSection(newActiveElement);
        }
      });
    });
  }
}
